import React, { useState } from "react";
import { useProcurementMethods } from "newui/store/common-types";
import { SelectWithLabel, BaseSelectWithLabelProps, SelectOption } from "../../InputWithLabel/SelectWithLabel";
import { useFormikFieldState } from "../useFormikField";
import { useField, useFormikContext } from "formik";
import { ProcurementModelGuidanceModal } from "./ProcurementModelGuidanceModal";

const guideLineText = "click to view guidelines for each Procurement Method";

export const ProcurementMethodSelect = ({
  label = "Procurement Method",
  placeholder = "Select procurement method",
  onChange: onChangeProp,
  hasError: hasErrorProp,
  errorText: errorTextProp,
  name,
  isMulti = true,
  ...rest
}: Omit<BaseSelectWithLabelProps, "options" | "isLoading">) => {

  const formik = useFormikFieldState(name);
  const [field, meta] = useField<number[] | number>({ name });
  const { setFieldValue } = useFormikContext<Record<string, number[] | null>>();
  const [isGuidanceOpen, setIsGuidanceOpen] = useState(false);

  const { values, isLoading } = useProcurementMethods();

  const handleChange = (selected: SelectOption | SelectOption[] | null) => {
    formik.markTouched();
    setFieldValue(name, isMulti ? (selected as SelectOption[])?.map((option) => option.value) : (selected as SelectOption)?.value, true);
    onChangeProp?.(selected);
  };



  const selectedValues = isMulti ? values.filter((option) => (field.value as number[])?.includes(option.value)) : values.find((option) => option.value === field.value) ?? null;

  return <>
    <SelectWithLabel
      options={values as SelectOption[]}
      isLoading={isLoading}
      label={label}
      placeholder={placeholder}
      value={selectedValues}
      name={name}
      hasError={hasErrorProp || formik.hasError}
      errorText={errorTextProp || formik.errorText}
      onChange={handleChange}
      isMulti={isMulti}
      guideLine={guideLineText}
      isGuideLineLink
      onGuideLineClick={() => setIsGuidanceOpen(true)}
      {...rest}
    />
    <ProcurementModelGuidanceModal
      isOpen={isGuidanceOpen}
      onClose={() => setIsGuidanceOpen(false)}
    />
  </>;
};
